module.exports = __webpack_public_path__ + "img/featureImg3.8815cf3d.png";